/**
 * Chrome the host's Live Tap page and the public viewer (TT-1110) share, so
 * the two pages read as one surface.
 */

// The chip's tone for a cassette's state (the doc read's: running, closing,
// closed, error).
export function statusTone(status) {
  if (status === "closed") {
    return "success";
  }
  if (status === "error") {
    return "error";
  }
  return "info";
}

// Toolbar buttons are enclosed (bordered, rounded square) so they read as
// distinct actions rather than blending in with the borderless round transport
// arrows. The left margin sits them off the drip count on the host page.
export const TOOL_BTN_SX = {
  color: "var(--color-text-secondary)",
  border: "1px solid var(--color-border-primary)",
  borderRadius: "8px",
  padding: "6px",
  marginLeft: "1rem",
  "&:hover": {
    borderColor: "var(--color-border-secondary)",
    backgroundColor: "var(--color-bg-tertiary)",
  },
  "&.Mui-disabled": {
    color: "var(--color-text-muted)",
    borderColor: "var(--color-border-primary)",
  },
};

// The accent variant: a manual background pin is active (TT-962), or the info
// panel is open — the toolbar reflects that a default is overridden.
export const TOOL_BTN_ACTIVE_SX = {
  ...TOOL_BTN_SX,
  color: "var(--color-accent-primary)",
  borderColor: "var(--color-accent-primary)",
  "&:hover": {
    borderColor: "var(--color-accent-primary)",
    backgroundColor: "var(--color-bg-tertiary)",
  },
};
